import React from 'react';
import type { AuthSectionProps } from '~/lib/types/netlify';
import { useTranslation } from '~/lib/hooks/useTranslation';

export const AuthSection = ({ isCheckingToken, tokenCheckCount, onConnect, onAbort }: AuthSectionProps) => {
  const { t, ready } = useTranslation(false);

  if (!ready) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3">
      <button
        onClick={onConnect}
        disabled={isCheckingToken}
        className="w-full px-6 py-2.5 bg-dualite-background-cta text-dualite-text-cta hover:bg-dualite-background-cta-hover
        rounded-md text-sm font-semibold shadow-sm transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed 
        flex items-center justify-center gap-2"
      >
        {isCheckingToken ? (
          <>
            <div className="i-ph:circle-notch w-4 h-4 animate-spin mr-2" />
            {t('modals.deploy.connecting', { seconds: 30 - tokenCheckCount })}
          </>
        ) : (
          t('modals.deploy.connectWithNetlify')
        )}
      </button>

      {isCheckingToken && (
        <button
          onClick={onAbort}
          className="w-full px-6 py-2.5 bg-transparent border border-dualite-border-secondary hover:border-dualite-border-primary
          rounded-md text-dualite-text-cta text-sm font-medium 
          hover:bg-white/5 transition-colors"
        >
          {t('modals.deploy.cancel')}
        </button>
      )}
    </div>
  );
};
